import { UiLoader } from '@experiences/ui-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

import { isOrgAdminSelector } from '../../store/selectors';
import { useCodedDashboardsContext } from './subcomponents/dashboards/hooks/useCodedDashboards';

const GovernanceV2IndexRedirect: React.FC = () => {
    const isOrgAdmin = useSelector(isOrgAdminSelector);
    const {
        pinned, isLoading,
    } = useCodedDashboardsContext();

    if (isOrgAdmin) {
        return (
            <Navigate
                to="policy-library"
                replace />
        );
    }

    if (isLoading && pinned.length === 0) {
        return (
            <div data-cy="governance-index-redirect-loading">
                <UiLoader type="full" />
            </div>
        );
    }

    // Already pinned-only, and the folder key rides along: the dashboard route resolves the app's URL
    // from folder context.
    const [ firstPinned ] = pinned;

    return (
        <Navigate
            to={firstPinned
                ? `dashboard/${firstPinned.id}?folderKey=${encodeURIComponent(firstPinned.deploymentFolder.key)}`
                : 'getting-started'}
            replace />
    );
};

export default GovernanceV2IndexRedirect;
